import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Alert = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.055 4.143a2.226 2.226 0 0 1 3.89 0l7.75 13.429C22.56 19.095 21.48 21 19.752 21H4.25c-1.729 0-2.81-1.905-1.945-3.428z'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.75 12H12v5.25'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <rect
          x='11.375'
          y='8.375'
          width='1.25'
          height='1.25'
          rx='0.625'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='0.25'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.945 4.143a2.226 2.226 0 0 0-3.89 0l-7.75 13.429C1.44 19.095 2.52 21 4.248 21H19.75c1.729 0 2.809-1.905 1.945-3.428zM10.75 11.25a.75.75 0 0 0 0 1.5h.5v4.5a.75.75 0 0 0 1.5 0V12a.75.75 0 0 0-.75-.75zm.5-2.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0'
        fill='currentColor'
      />
    )}
  </IconBase>
);
